// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"6244a4fc","213":"042bb37f","453":"d855a71b","667":"d317a722"}[chunkId] + ".chunk.js";
};